import {
  saveApplicationAsDraft as saveApplicationAsDraftApi,
  submitApplication as submitApplicationApi,
  withdrawApplication as withdrawApplicationApi
} from "../../Services/portalService";

export const getValidSteps = ({ template, user }) => {
  const { steps } = template;

  let validSteps = {};
  let firstStep = undefined;
  const applicationStepNames = [];
  var order = 0;
  var numberOfSteps = 0;
  //mapping the steps to a dictionary for faster access later
  (steps ?? [])
    .sort((a, b) => a.order - b.order)
    .forEach((step) => {
      const validStep = { ...step, order: order };

      const {
        renderer: {
          props: {
            doNotCountTowardsStepCounter = false,
            isApplicationStep = false,
          } = {},
        } = {},
      } = validStep;

      if (!doNotCountTowardsStepCounter) {
        validStep.stepNumber = ++numberOfSteps;
      }

      if (isApplicationStep) {
        applicationStepNames.push(step.name);
      }

      validSteps[`${step.name}`] = {
        ...validStep
      };

      if(!firstStep){
        firstStep = validSteps[`${step.name}`];
      }
      
      order++;
    });

  return { validSteps, numberOfSteps, firstStep, applicationStepNames };
};

export const saveApplicationAsDraft = async ({
  applicationId,
  applicationTypeId,
  application,
}) => {
  return await saveApplicationAsDraftApi({
    applicationTypeId,
    application: JSON.stringify(application ?? {}),
    applicationId,
  });
};

export const submitApplication = async ({
  applicationId,
  applicationTypeId,
  application,
}) => {
  return await submitApplicationApi({
    applicationTypeId,
    applicationId,
    application: JSON.stringify(application ?? {}),
  });
};

export const withdrawApplication = async (applicationId) => {
  return await withdrawApplicationApi(applicationId);
};